import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, mb, mt, p, pl, w100} from "@pg-design/helpers-css";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IRankingOffer} from "../../../types/IRankingOffer";
import {AwardedPlaceIndicator} from "./AwardedPlaceIndicator";

interface IProps {
    className?: string;
    offer: IRankingOffer;
}

export const AwardedOffersBox = ({className, offer}: IProps) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });
    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} className={className}>
            <a href={offerUrl} target="_blank" css={header}>
                <div css={[flex(), flexDirection("column")]}>
                    <div css={placeHolderMobile}>
                        <AwardedPlaceIndicator showOnMobile />
                    </div>

                    <img css={offerImage} alt={offer.name} src={offer.main_image?.m_img_350x230} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={[flex("flex-start", "center"), flexDirection("column")]}>
                    <Text as="p" mb="1.6rem" variant="headline_4">
                        {offer.name}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="none_secondary" iconRight={ChevronRightIcon} css={[mt(2), pl()]}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <AwardedPlaceIndicator showOnMobile={false} />
            </div>
        </div>
    );
};

const boxHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const boxDetailHolder = (theme: Theme) => css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(4, 4, 1)};
    }
`;

const placeHolderMobile = (theme: Theme) => css`
    background-color: ${theme.colors.primary};
    ${flexAbsoluteCenter};
    height: 4.8rem;
    max-height: 4.8rem;

    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;

const header = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;

const offerImage = (theme: Theme) => css`
    width: 100%;
    height: 25.6rem;
    min-height: 25.6rem;

    @media (min-width: ${theme.breakpoints.md}) {
        width: 28rem;
        height: 18.4rem;
        min-height: 18.4rem;
        border-radius: unset;
    }

    @media (min-width: ${theme.breakpoints.md}) {
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, mb, mt, p, pl, w100} from "@pg-design/helpers-css";
import {ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IRankingOffer} from "../../../types/IRankingOffer";
import {AwardedPlaceIndicator} from "./AwardedPlaceIndicator";

interface IProps {
    className?: string;
    offer: IRankingOffer;
}

export const AwardedOffersBox = ({className, offer}: IProps) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });
    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} className={className}>
            <a href={offerUrl} target="_blank" css={header}>
                <div css={[flex(), flexDirection("column")]}>
                    <div css={placeHolderMobile}>
                        <AwardedPlaceIndicator showOnMobile />
                    </div>

                    <img css={offerImage} alt={offer.name} src={offer.main_image?.m_img_350x230} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={[flex("flex-start", "center"), flexDirection("column")]}>
                    <Text as="p" mb="1.6rem" variant="headline_4">
                        {offer.name}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="none_secondary" iconRight={ChevronRightIcon} css={[mt(2), pl()]}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <AwardedPlaceIndicator showOnMobile={false} />
            </div>
        </div>
    );
};

const boxHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const boxDetailHolder = (theme: Theme) => css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(4, 4, 1)};
    }
`;

const placeHolderMobile = (theme: Theme) => css`
    background-color: ${theme.colors.primary};
    ${flexAbsoluteCenter};
    height: 4.8rem;
    max-height: 4.8rem;

    @media (min-width: ${theme.breakpoints.md}) {
        display: none;
    }
`;

const header = (theme: Theme) => css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;

const offerImage = (theme: Theme) => css`
    width: 100%;
    height: 25.6rem;
    min-height: 25.6rem;

    @media (min-width: ${theme.breakpoints.md}) {
        width: 28rem;
        height: 18.4rem;
        min-height: 18.4rem;
        border-radius: unset;
    }

    @media (min-width: ${theme.breakpoints.md}) {
    }
`;
